import type { CallCenter } from '@/apis/generated/dialpad-contact';
import type { PDUser } from '@/use-user';

export const isCompanyAdmin = (user: PDUser): boolean => {
  return (
    // looks weird, but linter forced me to do this
    (user.isSuperAdmin ?? false) ||
    (user.isGoogleAdmin ?? false) ||
    (user.isMicrosoftAdmin ?? false)
  );
};

export const isOfficeAdmin = (user: PDUser, officeKey: string): boolean => {
  return user.adminOffices.has(officeKey);
};

export const isCallCenterAdmin = (
  user: PDUser,
  callCenter: CallCenter,
): boolean => {
  return user.adminGroups.has(callCenter.shortKey ?? '');
};

/**
 * replica of UV get_group_edit
 * @param user
 * @param officeKey
 */
export const canEditCallCenter = (
  user: PDUser,
  callCenter: CallCenter,
): boolean => {
  if (isCompanyAdmin(user)) return true;
  if (isOfficeAdmin(user, `Office:${callCenter.officeId ?? ''}`)) return true;
  if (isCallCenterAdmin(user, callCenter)) return true;

  return false;
};
